import React from "react";

import Icon from "./Icon";

function Spinner({ size = 18 }) {
	return (
		<div className="animate-spin">
			<Icon iconName="loading" size={size} />
		</div>
	);
}

export default Spinner;
